import React, { Component } from 'react';
import AdminHeader from './Main/AdminHeader'
import Header from './Main/Header'
import Viewer from './Main/Viewer'
import SplashScreen from './Main/SplashScreen'
import { ReactComponent as IconLoading } from './MainIcons/loading.svg';
import './Main.css';

class Main extends Component {
	// Called when mounted - only use when setting state directly or when binding event handlers
	constructor(props) {
		super(props);

	  // if app.browser.mobile or webkitMajorVer and webkitMajorVer < 537
	  //   #since safari is so slow pre webkit 537, just play no canvas as well!
	  //   app.useCanvas = no
	  //   @$el.addClass 'no-calc-transitions'

	  // app.throttle = yes if safari and not chrome and webkitMajorVer and webkitMajorVer >= 537

	  // if not Modernizr.video.h264
	  //   # If the browser does not support h.264, we will post a browser not supported message
	  //   app.useCanvas = no
	  //   @$el.addClass 'no-calc-transitions'

	// beforeRender: ->
	//   @overlay = new OverlayView
	//     model: @product.clone()
	//     siteModel: @site
	//   @header = new HeaderView
	//     model: @site
	//   @viewer = new ViewerView
	//     model: @product

		//this.state = props.data;
		// When video is unpublished, don't show the splashscreen.
		this.state = {
			showSplash: true
		};
	}

	componentDidMount() {
		window.addEventListener('hashchange', this.gotoHandler);
	}

	componentWillUnmount() {
		try {
			window.removeEventListener('hashchange', this.gotoHandler);
		} catch (err) {
		}
	}

	// Goto on change - dismiss splash screen if necessaryy
	gotoHandler = () => {
		window.removeEventListener('hashchange', this.gotoHandler);
		this.hideSplash();
		const urlHash = window.location.hash;

		let secondsString = urlHash.substring(6);
		if (isNaN(secondsString) || Number(secondsString) % 1 !== 0) {
			console.error("URL `goto` hash parameter is not valid. It must be an integer representing seconds elapsed since the beginning of the capture.");
		} else {
			let start = Number(secondsString);
			console.log(`Starting at ${start}!`);
			this.props.updatePlayerState({ initialTime: start});
		}
	}

	hideSplash = () => {
		this.setState({
			showSplash: false
		});
	}

	render() {
		let classNames = 'Main layout layout-main layout-loading';
		return (
			<div className={classNames}>
				<div className="content clearfix" key="content clearfix" onClick={this.hideSplash}>
				{ this.state.showSplash && this.props.data.embed
					? <SplashScreen data={this.props.data} updatePlayerState={this.props.updatePlayerState}/>
					: [
					(<AdminHeader key="main1" data={this.props.data} />),
					(<Header key="main2" data={this.props.data} updatePlayerState={this.props.updatePlayerState} />),
					(<div key="main3" className="content-inner">
						{ this.props.data.message === false && this.props.data.recording === false ? <Loading key="main4" /> : null }
						{ this.props.data.message !== false ? <Message key="main5" data={this.props.data} /> : null }
						{ this.props.data.recording !== false ? <Viewer key="main6" data={this.props.data} updatePlayerState={this.props.updatePlayerState} /> : null }
					</div>)
					]
				}
				</div>
			</div>
		);
	}
}

class Message extends Component {
// messageType - currently only errors
// message: "The requested recording could not be found.",…}
// code: 404
// message: "The requested recording could not be found."
// solution: "Please verify that the URL is correct."

	render() {
		var modalContent = this.props.data.message;

		return (
			<div className="notice-outer">
				<div className="notice-box">
					<h2>An error has occurred...</h2>

					<div className="notice-message">{modalContent.message}</div>
					<div className="notice-solution">{modalContent.solution}</div>

					<div className="notice-contact">For assistance please contact <a href="mailto:{modalContent.contact_email}">{modalContent.contact_email}</a></div>
				</div>
			</div>
		);
	}
}

class Loading extends Component {
	render() {
		return (
			<div className="notice-outer">
				<div className="loading-box"><IconLoading /> loading</div>
			</div>
		);
	}
}

export default Main;

